var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { memo } from 'react';
import loadYMaps from '../../utils/loadYMaps';
import { accessPromise, waitPromiseLike } from '../../utils/suspense';
var LoaderSuspense = function (props) {
    var children = props.children, _a = props.lang, lang = _a === void 0 ? 'ru_RU' : _a, _b = props.version, version = _b === void 0 ? '2.1' : _b, query = __rest(props, ["children", "lang", "version"]);
    var obj = accessPromise(function () { return loadYMaps(__assign({ version: version, lang: lang }, query)); }, 
    // можно сделать более умный кеш с учетом аргументов,
    // но для данной цели нет смысла
    'loadYMaps');
    waitPromiseLike(obj);
    // PropsWithChildren нельзя возвращать 8)
    return children;
};
export default memo(LoaderSuspense);
